import template from './ko-field-input-date-range.html';

class DateRangeInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.$input = params.$input;
	}
}


export default {
	name: 'ko-field-input-date-range',
	viewModel: DateRangeInputComponentVM,
	module_type: 'ko',
	template: template
};
